import React from 'react';
import { AppBar, Toolbar, Typography, Box,  } from '@mui/material';
import { useNavigate } from "react-router-dom";

import { useConfigContext } from '../functions/ConfigContext';

const PublicAppBar = () => {

  const errorFormName = "Public App Bar";

  const { configLibrary } = useConfigContext();
  const navigate = useNavigate();

  const goToSupportSelection = () => {
    window.open(configLibrary.supportUrl, '_blank', 'noopener,noreferrer');
  };


    return (
        <AppBar position="fixed" className="appBar" sx={{
            bgcolor: '#131e42',
            height: '48px',
            maxHeight: '48px',
            minHeight: '48px',
        }}>
            <Toolbar style={{minHeight: '48px', maxHeight: '48px',}} className="container-fluid container-fluid-menu">

                <img src='/images/Y-Trac Logo.png' alt="logo" width={128} height={48} className='me-1'></img>


                <Box sx={{ flexGrow: 1 }} />
                <button onClick={goToSupportSelection} className="support-button">
                    Support
                </button>

            </Toolbar>
        </AppBar>
    );
};

export default PublicAppBar;
